// =============================================================
// JST date helpers — the whole house runs on JST.
// =============================================================

export function jstNow(): Date {
  return new Date(Date.now() + 9 * 3600 * 1000)
}

export function jstTodayStr(): string {
  return jstNow().toISOString().slice(0, 10)
}

export function dstr(y: number, m: number, d: number): string {
  return y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0')
}

/** Format "HH:MM" in JST locale. */
export function formatTimeJa(date: Date): string {
  return date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })
}

/** Format "HH:MM" in zh-CN locale. */
export function formatTimeZh(date: Date): string {
  return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })
}